import { Field, Item, Link, LinkField, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import { FilterGroup } from 'src/types/FilterGroup';
import { ResourceListItem } from 'src/types/ResourceListItem';
import { SocialSharingOptions } from 'src/types/SocialSharingOptions';

import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import Advert from 'src/components/advert/Advert/Advert';
import { ListingCard } from 'src/components/search/_ListingCard/_ListingCard';

import styles from './_Listing.module.css';

export type PinnedItem = {
	Title: Field<string>;
	Description: Field<string>;
	Link: LinkField;
};

type ListingProps = {
	Advert?: ComponentProps & {
		fields: Item & {
			Title: Field<string>;
			NarrowId: Field<string>;
			WideId: Field<string>;
		};
	};
	items: ResourceListItem[];
	filters: FilterGroup[] | undefined;
	pinnedItem?: PinnedItem;
	loading?: boolean;
	wildCardUrl: string | undefined;
	favouriteButtonText: Field<string>;
	unfavouriteText: Field<string>;
	registeredUserText: Field<string>;
	rcnMemberText: Field<string>;
	rcniPlusSubscriberText: Field<string>;
	organisationalProductText: Field<string>;
	openAccessText: Field<string>;
	cpdHoursText: Field<string>;
	subjectLinkPrependedText: Field<string>;
	shareOptions: SocialSharingOptions;
	noShareOptions: Field<string>;
	shareButtonToolTip: Field<string>;
	setSubjectValue?: (name: string, value: string) => void;
};

export function Listing(props: ListingProps): JSX.Element {
	const isEditing = IsSitecoreEditing();

	return (
		<section className={styles.listing}>
			{props.items.map((item, index) => {
				return (
					<ListingCard
						item={item}
						key={index}
						filters={props.filters}
						wildCardUrl={props.wildCardUrl}
						favouriteButtonText={props.favouriteButtonText}
						unfavouriteText={props.unfavouriteText}
						registeredUserText={props.registeredUserText}
						rcnMemberText={props.rcnMemberText}
						rcniPlusSubscriberText={props.rcniPlusSubscriberText}
						organisationalProductText={props.organisationalProductText}
						openAccessText={props.openAccessText}
						subjectLinkPrependedText={props.subjectLinkPrependedText}
						shareButtonToolTip={props.shareButtonToolTip}
						shareOptions={props.shareOptions}
						noShareOptions={props.noShareOptions}
						setSubjectValue={props.setSubjectValue}
						cpdHoursText={props.cpdHoursText}
					/>
				);
			})}

			{!props.Advert && props.pinnedItem && (isEditing || props.pinnedItem.Title?.value) && (
				<article className={`${styles.cta} blueDark rounded`}>
					<Text tag="h3" field={props.pinnedItem.Title} className={styles.ctaTitle} />
					<Text tag="p" field={props.pinnedItem.Description} className={styles.ctaBody} />

					<Link field={props.pinnedItem.Link} className="button white" />
				</article>
			)}

			{props.Advert && <Advert {...props.Advert} asListingCard={true} />}
		</section>
	);
}
